import { createGlobalStyle } from 'styled-components'

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    outline: none;
  }

  *::before,
  *::after {
    box-sizing: border-box;
  }
  
  html {
    height: 100%;
  }

  body {
    font-family: 'Open Sans', sans-serif;
    height: 100%;
  }

  a {
    font-family: 'Open Sans', sans-serif;
    text-decoration: none;
  }

  li {
    list-style-type: none;
  }

  table {
    margin: 0;
  }

  #root {
    height: 100%;
  }
`;